import { render, staticRenderFns } from "./document-viewer.vue?vue&type=template&id=0c09c80c&"
import script from "./document-viewer.vue?vue&type=script&lang=js&"
export * from "./document-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports